'use strict';

exports.__esModule = true;
exports.loaders = exports.dynamicArgumentsMap = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactRouter = require('react-router');

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _pageActions = require('../actions/page-actions');

var _pageActions2 = _interopRequireDefault(_pageActions);

var _utils = require('./utils');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _globalRedux$globalAc = _doctifyGlobalRedux2.default.globalActions.ListingsActions,
    getInsurers = _globalRedux$globalAc.getInsurers,
    getSpecialties = _globalRedux$globalAc.getSpecialties,
    getConditions = _globalRedux$globalAc.getConditions,
    getProcedures = _globalRedux$globalAc.getProcedures,
    getTreatmentGroups = _globalRedux$globalAc.getTreatmentGroups,
    getProfessionalBodies = _globalRedux$globalAc.getProfessionalBodies,
    getHealthChecks = _globalRedux$globalAc.getHealthChecks;


var specialistCall = function specialistCall(id, hospitalList, network, xhrConfig) {
	hospitalList = parseInt(hospitalList, 10);
	hospitalList = isNaN(hospitalList) ? undefined : hospitalList;
	return function (dispatch) {
		return getSpecialties(xhrConfig)(dispatch).then(function (specialties) {
			return _pageActions2.default.loadSpecialistProfile(id, specialties.keywords, hospitalList, network, xhrConfig)(dispatch);
		}).then(function (response) {

			var nextCalls = [_pageActions2.default.loadSpecialistAvailabilities(response.specialist.id, { startdate: (0, _moment2.default)().add(2, 'days').format('YYYY-MM-DD HH:mm') }, xhrConfig)];
			if (response && response.specialist && response.specialist.author_id) {
				nextCalls.push(_pageActions2.default.loadSpecialistBlogPosts(response.specialist.author_id, xhrConfig));
			}

			return _bluebird2.default.all(nextCalls.map(function (call) {
				return dispatch(call);
			})).then(function (results) {
				var availabilities = results && results.length && results[0];
				var totalDays = availabilities && availabilities.length;

				if (totalDays) {
					return dispatch(_pageActions2.default.setLatestAvailabilityFound((0, _moment2.default)(availabilities[totalDays - 1].start_date)));
				} else {
					var startDate = (0, _moment2.default)().add((0, _utils.getVisibleCalendarDays)(), 'd');
					return dispatch(_pageActions2.default.loadSpecialistAvailabilities(response.specialist.id, {
						startdate: startDate.format('YYYY-MM-DD'),
						enddate: startDate.clone().add(_constants.NEAREST_AVAILABILITY_END_DAYS, 'd').format('YYYY-MM-DD'),
						practice_filter: null,
						group_by_date: true,
						for_public_view: true
					}, xhrConfig)).then(function (nearestAvailabilities) {
						if (nearestAvailabilities && nearestAvailabilities.length) {
							return dispatch(_pageActions2.default.setNearestAvailability(nearestAvailabilities[0].start_date));
						}
						return _bluebird2.default.resolve();
					});
				}
			});
		});
	};
};

/**
	Here we specify where to find the arguments to replace in the loaders int the request.
**/
var dynamicArgumentsMap = exports.dynamicArgumentsMap = {
	_id_: 'params.id',
	_hospitalList_: 'query.hospitalList',
	_network_: 'query.network'
};

/**
	Loaders.
**/
var loaders = exports.loaders = [{
	key: 'listings.insurers',
	action: getInsurers
}, {
	key: 'listings.specialties',
	action: getSpecialties
}, {
	key: 'listings.conditions',
	action: getConditions
}, {
	key: 'listings.procedures',
	action: getProcedures
},
// {
// 	key: 'listings.healthChecksTreatmentGroups',
// 	action: getTreatmentGroups,
// 	arguments: ['heath_check']
// },
// {
// 	key: 'listings.scansTreatmentGroups',
// 	action: getTreatmentGroups,
// 	arguments: ['scan']
// },
{
	key: 'listings.professionalBodies',
	action: getProfessionalBodies
},
// {
// 	key: 'listings.healthChecks',
// 	action: getHealthChecks
// },
{
	key: 'loadedUri',
	action: _pageActions2.default.loadUri,
	arguments: ['_id_'],
	dynamicArguments: ['_id_']
}, {
	key: 'loadedUri',
	action: _pageActions2.default.loadSpecialistReviews,
	arguments: ['_id_', ''],
	dynamicArguments: ['_id_']
}, {
	key: 'loadedUri',
	action: _pageActions2.default.loadSpecialistAggregateReview,
	arguments: ['_id_', ''],
	dynamicArguments: ['_id_']
}, {
	key: 'loadedUri',
	action: _pageActions2.default.loadSpecialistPeerRecommendations,
	arguments: ['_id_'],
	dynamicArguments: ['_id_']
}, {
	key: 'loadedUri',
	action: _pageActions2.default.updateCalendarStartDate,
	arguments: [_moment2.default.utc().add(2, 'days')]
}, {
	key: 'loadedUri',
	action: specialistCall,
	arguments: ['_id_', '_hospitalList_', '_network_'],
	dynamicArguments: ['_id_', '_hospitalList_', '_network_']
}];


// WEBPACK FOOTER //
// ./components/specialist-page/lib/utils/loaders.js